import baseService from "@common/externos/services/base.service";
import store from "@common/store/store";

const tbRoute = window.api_routes.smarAPD_Tributario_Domain;
const commonRoute = window.api_routes.smarAPD_Common;

let http = baseService(store, tbRoute);

let controller = "/MovimentacaoExterno/";

const apiDef = {
  consultarProtocoloByCpfCnpj(data, tokenRecaptcha) {
    return http.post(
      `${controller}ConsultaProtocoloByCpfCnpj`,
      {CpfCnpj: data},
      tokenRecaptcha
    );
  },
  consultarProtocoloByProtocolo(data, tokenRecaptcha) {
    return http.post(
      `${controller}ConsultaProtocoloByProtocolo`,
      data,
      tokenRecaptcha
    );
  },
  consultarProtocoloAnalise(numeroProtocolo) {
    return http.get(`${controller}ConsultaProtocoloAnalise/${numeroProtocolo}`);
  },
  ConsultaProtocoloDadosAnalise(idAnaliseOrgao) {
    return http.get(`${controller}ConsultaProtocoloDadosAnalise/${idAnaliseOrgao}`);
  },
};

export default apiDef;
